import AdminLayout from "../../commponents/layout/adminLayout";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Pencil } from "lucide-react";
import { getUserById } from "../../api/userApi";
import { showError } from "../../utils/ alert";

interface User {
  id: number;
  name: string;
  username: string;
  phone: string;
  email: string;
  role: string;
  status: string;
  createdAt: string;
}

export default function UserDetail() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState<User | null>(null);
  const [loading, setLoading] = useState(false);

  const fetchUser = async () => {
    if (!id) return;

    try {
      setLoading(true);
      const { data } = await getUserById(Number(id));
      setUser(data.data);
    } catch (error) {
      showError(
        "Failed",
        "Failed to Load data."
    );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const formatDate = (value?: string) => {
    if (!value) return "-";
    const date = new Date(value);
    return date.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  return (
    <AdminLayout>
      <div className="bg-white rounded-3xl p-6">
        <div className="mb-4 text-sm text-gray-500">
          User Management &gt; User Management List &gt; Detail User
        </div>

        <div className="flex items-center justify-between mb-6">
          <h2 className="text-xl font-semibold">Basic Information</h2>

          <button
            onClick={() => navigate(`/user-management?editId=${id}`)}
            className="flex items-center gap-2 rounded-lg bg-blue-600 px-4 py-2 text-white hover:bg-blue-700">
            <Pencil size={16} />
            Edit User
          </button>
        </div>

        {loading && <p>Loading...</p>}

        {!loading && !user && <p>User not found.</p>}

        {!loading && user && (
          <div className="grid grid-cols-2 gap-y-4 gap-x-8">
            <div>
              <span className="text-gray-500">Nama</span>
              <p className="font-medium">{user.name}</p>
            </div>
            <div>
              <span className="text-gray-500">Password</span>
              <p className="font-medium">••••••••</p>
            </div>
            <div>
              <span className="text-gray-500">User Name</span>
              <p className="font-medium">{user.username}</p>
            </div>
            <div>
              <span className="text-gray-500">Level</span>
              <p className="font-medium">{user.role}</p>
            </div>
            <div>
              <span className="text-gray-500">No. Telp</span>
              <p className="font-medium">{user.phone || "-"}</p>
            </div>
            <div />
            <div>
              <span className="text-gray-500">Email</span>
              <p className="font-medium">{user.email}</p>
            </div>
            <div />
            <div className="col-span-2 pt-2 border-t">
              <span className="text-gray-500">Create at</span>
              <p className="font-medium">{formatDate(user.createdAt)}</p>
            </div>
          </div>
        )}
      </div>
    </AdminLayout>
  );
}
